// getters.js

import Cookies from 'js-cookie';

export default {
    isAuthenticated: state => state.isAuthenticated,
    user: state => state.user,
    access_token: state => `Bearer ${state.access_token}`,
};
